import React, { useState, useEffect } from "react";
import { Col, FormGroup, Input, Label, Row, Button } from "reactstrap";
import FeatureContainer from "../../../Layout/Containers/FeatureContainer";
import { useTandaTerima } from "../../../Context/TandaTerimaContext";

const KurirSelection = ({ onKurirSelect }) => {
  const tandaTerimaAPI = useTandaTerima();
  const [kurirList, setKurirList] = useState([]);
  const [selectedKurir, setSelectedKurir] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchKurirList = () => {
      tandaTerimaAPI.getKurir().then((res) => {
        setKurirList(res.data);
        setLoading(false);
      })
    };

    fetchKurirList();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedKurir) {
      const kurirObj = kurirList.find(kurir => kurir.id.toString() === selectedKurir);
      
      localStorage.setItem("selectedKurir", JSON.stringify(kurirObj));
      
      if (onKurirSelect) {
        onKurirSelect(kurirObj);
      } else {
        window.location.reload();
      }
    }
  };

  return (
    <FeatureContainer
      title={"Pilih User"}
    >
      {loading ? (
        <div className="text-center">Loading...</div>
      ) : (
        <form onSubmit={handleSubmit}>
          <Row>
            <Col sm="12">
              <FormGroup>
                <Label for="kurirSelect">Nama User</Label>
                <Input
                  id="kurirSelect"
                  type="select"
                  value={selectedKurir}
                  onChange={(e) => setSelectedKurir(e.target.value)}
                  required
                >
                  <option value="">-- User --</option>
                  {kurirList.map((kurir) => (
                    <option key={kurir.id} value={kurir.id}>
                      {kurir.nama}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm="12" className="text-center">
              <Button color="primary" type="submit" disabled={!selectedKurir}>
                Lanjutkan
              </Button>
            </Col>
          </Row>
        </form>
      )}
    </FeatureContainer>
  );
};

export default KurirSelection;